import React from 'react'
import { connect } from "react-redux";
import { GetDepositAccountByAmount, SetDepositOldBank, GetDepositStepTwoInProgressDetails, InsertMemberDepositStepTwoAccessRecord, SetDepositMisc, SetDepositNextStep } from '$Deposits/store/actions/DepositAction'
import { SetDepositPayments_LB } from '$Deposits/store/actions/DepositPost'
import { GetParamsData } from '$Deposits/lib/LibCommonData'
import { LB_Submit } from '$Deposits/store/actions/DepositEvent'


class LB extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isDummyBank: false,
            // modalVisible: true,
            curMethodCodeActive: '',
            curRemainingCountdownTime: '',
        };
    }

    _initMethodCode(initial = false) {
        const { GetDepositStepTwoInProgressDetails, SetDepositMisc } = this.props;
        return new Promise((resolve, reject) => {
            GetDepositStepTwoInProgressDetails().then(res => {
                if (!res) {
                    SetDepositMisc('IS_SKIP_STEP1', false)
                    resolve(initial ? false : true)
                } else {
                    SetDepositMisc('IS_SKIP_STEP1', initial)
                    resolve(true)
                }
            }).catch(err => {
                reject(err);
            });
        });
    }

    componentDidUpdate() {
        const { MethodCodeActive, SetDepositNextStep } = this.props;
        const { curMethodCodeActive } = this.state;
        if (MethodCodeActive && MethodCodeActive != curMethodCodeActive) {
            this.setState({ curMethodCodeActive: MethodCodeActive }, () => {
                this._initMethodCode(true).then(res => SetDepositNextStep(res))
            });
        }
    }
    componentDidMount() {
    }
    componentWillUnmount() {

    }

    render() {
        const { LivechatClick } = GetParamsData()
        const {
            GetDepositAccountByAmount,
            InsertMemberDepositStepTwoAccessRecord,
            DepositNextStep,
            DepositSuccessPage,
            DepositOldBank,
            SetDepositOldBank,
            TipsView,
            MoneyInput,
            BankSelect,
            SubmitBtn,
            NextStep,
            SuccessPage,
            OldBank,
            OldBankLine,
            UserBankSelect,
            MethodsDetails,
            BankNone,
            Modal,
            MethodCodeActive,
            SetDepositPayments_LB,
            MethodsActive,
            AvailableMethods,
            SetDepositNextStep,
            BanksBankAccounts = [],
        } = this.props
        const { availableMethods = [], } = MethodsActive || {}

        //UniqueAmt渠道
        let isUniqueAmt = availableMethods.find((v) => { return v.methodCode == 'UniqueAmt' }) || false
        const { isAutoAssign = false } = MethodsDetails?.setting || {}

        return (
            <>

                {
                    //没有银行卡
                    !DepositNextStep && !DepositSuccessPage && !DepositOldBank && BanksBankAccounts.length == 0 ? (
                        <>
                            <BankNone LivechatClick={LivechatClick} methods={'LB'} onChange={() => { SetDepositOldBank(true) }} />
                        </>) : (
                            <>
                                {/* UniqueAmt渠道Modal */}
                                {/* <Modal
                                    modalVisible={MethodCodeActive == 'UniqueAmt' && this.state.modalVisible}
                                    title={'แจ้งเตือน'}
                                    okText={'ปิด'}
                                    msg={`เพื่อการปรับยอดที่รวดเร็วยิ่งขึ้น เราแนะนำให้ทำการฝาก ตามยอดที่ระบบระบุเท่านั้น`}
                                    onChange={() => {
                                        this.setState({ modalVisible: false })
                                    }}
                                /> */}
                                {
                                    !DepositNextStep && !DepositSuccessPage && !DepositOldBank && !isUniqueAmt &&
                                    <TipsView msg={`บัญชีในการฝาก-ถอน ต้องเป็นชื่อบัญชีเดียวกับชื่อที่ใช้สมัครเท่านั้น \nไม่รองรับการฝากผ่านตู้บุญเติม, 7-Eleven, True wallet และ Airpay \nทุกการฝากมียอดหมุนเวียน 1 เท่าก่อนการถอน (หากไม่รับโบนัส)`} />
                                }
                                {
                                    !DepositNextStep && !DepositSuccessPage && !DepositOldBank &&
                                    <>
                                        <AvailableMethods />
                                        <MoneyInput />
                                        <UserBankSelect />
                                        {!isAutoAssign && <BankSelect />}
                                        {/* <OldBankLine
                                            onChange={() => { SetDepositOldBank(true) }}
                                            msg={'ฝากเข้าบัญชีธนาคารเก่า'}
                                        /> */}
                                        <SubmitBtn
                                            OldBankLine={<OldBankLine
                                                onChange={() => { SetDepositOldBank(true) }}
                                                msg={'ฝากเข้าบัญชีธนาคารเก่า'}
                                            />}
                                            submitBtn={LB_Submit}
                                            onPress={() => {
                                                if (MethodCodeActive == 'UniqueAmt') {
                                                    //UniqueAmt渠道
                                                    SetDepositPayments_LB().then((result) => {
                                                        if (!!Object.keys(result.data).length) {  // Check if the first action was successful
                                                            if(result.data?.isDummyBank)
                                                                this.setState({isDummyBank: true})
                                                            else
                                                                this._initMethodCode().then((shouldSetNextStep) => {
                                                                    if (shouldSetNextStep) {
                                                                        SetDepositNextStep(true);
                                                                    }
                                                                });
                                                        }
                                                    }).catch((error) => {
                                                        console.error("Error in SetDepositPayments_LB:", error)
                                                    })
                                                } else {
                                                    GetDepositAccountByAmount()
                                                        .then((result) => {
                                                            if (result.data) {  // Check if the first action was successful
                                                                if(!result.data?.isDummyBank) { //only insert record if not dummy bank to prevent stuck loop
                                                                    InsertMemberDepositStepTwoAccessRecord(result.data).then((result) => {
                                                                        if (result) {  // Check if the first action was successful
                                                                            this._initMethodCode().then((shouldSetNextStep) => {
                                                                                if (shouldSetNextStep) {
                                                                                    SetDepositNextStep(true);
                                                                                }
                                                                            });
                                                                        }
                                                                    }).catch((error) => {
                                                                        console.error("Error in InsertMemberDepositStepTwoAccessRecord:", error)
                                                                    })
                                                                } else {
                                                                    this.setState({
                                                                        isDummyBank: true
                                                                    })
                                                                }
                                                            }
                                                        })
                                                        .catch((error) => {
                                                            console.error("Error in GetDepositAccountByAmount:", error)
                                                        })
                                                }
                                            }}
                                            submitBtnItem={'ถัดไป'}
                                        />
                                    </>
                                }
                                {
                                    //下一步
                                    DepositNextStep &&
                                    <NextStep />
        
                                }
                                <Modal
                                    modalVisible={this.state.isDummyBank}
                                    title={'การฝากเงินล้มเหลว'}
                                    header={true}
                                    okText={'ทำการฝากใหม่'}
                                    cancelText={"ปิด"}
                                    msg={`ขออภัยไม่มีธนาคารให้บริการในขณะนี้ รายการฝากนี้ จะถูกยกเลิก กรุณาทำรายการฝากด้วยช่องทางอื่น`}
                                    onChange={() => {
                                        this.setState({
                                            isDummyBank: false
                                        })
                                        GetDepositAccountByAmount(true)
                                    }}
                                    modes={'warning'}
                                />
                            </>
                    )
                }
                {
                    //存款成功
                    DepositSuccessPage &&
                    <SuccessPage />
                }
                {
                    DepositOldBank &&
                    <OldBank />
                }
            </>

        );
    }
}

const mapStateToProps = state => ({
    MethodsDetails: state.MethodsDetails,
    DepositNextStep: state.DepositNextStep,
    DepositSuccessPage: state.DepositSuccessPage,
    DepositOldBank: state.DepositOldBank,
    MethodCodeActive: state.MethodCodeActive,
    MethodsActive: state.MethodsActive,
    BanksBankAccounts: state.BanksBankAccounts,
});
const mapDispatchToProps = {
    SetDepositMisc,
    SetDepositNextStep,
    GetDepositAccountByAmount: (data = false) => GetDepositAccountByAmount(data),
    InsertMemberDepositStepTwoAccessRecord: (data = {}) => InsertMemberDepositStepTwoAccessRecord(data),
    GetDepositStepTwoInProgressDetails: () => GetDepositStepTwoInProgressDetails('LB'),
    SetDepositOldBank: (data = false) => SetDepositOldBank(data),
    SetDepositPayments_LB: (data = {}) => SetDepositPayments_LB(data)
};
export default connect(mapStateToProps, mapDispatchToProps)(LB);


